import './ToggleSwitch.css'

interface ToggleSwitchProps {
    checked: boolean
    onChange: (checked: boolean) => void
    label?: string
}

function ToggleSwitch({
    checked,
    onChange,
    label,
}: ToggleSwitchProps): React.JSX.Element {
    const handleToggle = () => {
        onChange(!checked)
    }

    return (
        <div className="toggle-switch">
            {label && <span className="label">{label}</span>}
            <div
                className={`switch ${checked ? 'checked' : ''}`}
                onClick={handleToggle}
                role="button"
                tabIndex={0}
                aria-pressed={checked}
            >
                <div className="slider" />
            </div>
        </div>
    )
}

export default ToggleSwitch
